import axios from "axios";

// Declare the URL for the backend server.
const baseURL = "https://apim-np-d-idb-integration.iadb.org/ext/slo/api";

const authService = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    "ocp-apim-subscription-key": "8e05f19b1ceb4a8cb4ae4c624a383cdf",
  },
});
/**
 *
 * @param {string} url Request URL
 * @returns Request response object
 */
export async function sendRequest(url) {
  return authService
    .get(url)
    .then((response) => {
      if (response.status !== 200) return "ERROR_LOADING_DATA";
      return response;
    })
    .catch(() => {
      return "ERROR_LOADING_DATA";
    });
}